<p-toast></p-toast>

<div class="payment-wrapper">
  @if (loading()) {
    <div class="payment-loading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>{{ 'payment_secure' | translateText }}...</span>
    </div>
  }

  @if (paid()) {
    <div class="payment-success">
      <div class="success-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <h3>{{ 'payment_success' | translateText }}</h3>
      <p>{{ 'payment_complete_to_book' | translateText }}</p>
    </div>
  }

  @if (!loading() && !paid()) {
    <div class="payment-card">
      <div class="payment-header">
        <div class="payment-header-left">
          <i class="pi pi-lock payment-lock-icon"></i>
          <div>
            <h3 class="payment-title">{{ 'payment_secure' | translateText }}</h3>
            <p class="payment-subtitle">SSL — Stripe</p>
          </div>
        </div>
        @if (intentData()) {
          <div class="payment-amount-badge">
            {{ formattedAmount }}
          </div>
        }
      </div>

      <!-- Resumen consulta -->
      @if (patientName) {
        <div class="payment-summary">
          <i class="pi pi-user me-2"></i>
          <span>{{ patientName }}</span>
        </div>
      }

      <!-- Error de tarjeta -->
      @if (error()) {
        <div class="payment-error">
          <i class="pi pi-exclamation-triangle me-2"></i>
          {{ error() }}
        </div>
      }

      <div class="payment-elements-wrapper">
        <div id="stripe-payment-element"></div>
      </div>

      <button class="payment-submit-btn" [disabled]="processing()" (click)="onSubmit()">
        @if (processing()) {
          <i class="pi pi-spin pi-spinner me-2"></i>
          {{ 'payment_processing' | translateText }}
        } @else {
          <i class="pi pi-lock me-2"></i>
          {{ 'payment_secure' | translateText }} — {{ formattedAmount }}
        }
      </button>
      <div class="payment-security">
        <img
          src="https://js.stripe.com/v3/fingerprinted/img/visa-365725566f9578a9589553aa9296d178.svg"
          alt="Visa"
          class="card-logo"
        />
        <img
          src="https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg"
          alt="Mastercard"
          class="card-logo"
        />
        <img
          src="https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg"
          alt="Amex"
          class="card-logo"
        />
        <span class="powered-by">Powered by <strong>Stripe</strong></span>
      </div>
    </div>
  }
</div>
